import {useApi} from "@/api";

export default function NextButton({onClick, text, disabled}) {
    const {loading} = useApi()
    return (
        <div className={"relative"}>
            <button
                className={"daisy-btn min-w-[246px] text-[20px] leading-[30px] text-white bg-brand-blue rounded-lg font-normal border-none px-[40px] h-[64px] inline-flex items-center text-center justify-center hover:bg-brand-orange transition-colors disabled:!bg-brand-blue disabled:opacity-40"}
                onClick={onClick}
                type={"submit"}
                disabled={disabled || loading}
            >
                {text || 'Next Step'}
            </button>
            {loading && (
                <div className={"size-[48px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"}>
                    <svg viewBox="0 0 50 50"><circle cx="25" cy="25" r="20" fill="none" className={"stroke-brand-blue"} strokeWidth="3" vectorEffect="non-scaling-stroke" strokeLinecap="round" strokeDasharray="60 120"><animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite"></animateTransform></circle></svg>
                </div>
            )}
        </div>
    )
}
